import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "@apollo/client";

export const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                article: {
                    keyArgs: [],
                    merge(existing, incoming) {
                        return {
                            records: [...(existing?.records || []), ...(incoming?.records || [])]
                        }
                    },
                },
            },
        },
    },
});

//DEV URLS
// export const APP_URLS = {
//     cms_edge: "http://173.212.233.220:7020/api/cms-edge/v1/graphql",
//     cms: "http://173.212.233.220:7010/api/cms/v1/graphql",
//     vacancy_apply: "http://173.212.233.220:7010/cms/api/v1/vacancy/send-cv"
// }

//PROD URLS
export const APP_URLS={
    cms_edge:"https://app.orangefit.am/api/cms-edge/v1/graphql",
    cms:"https://app.orangefit.am/api/cms/v1/graphql",
    vacancy_apply: "https://app.orangefit.am/api/cms/api/v1/vacancy/send-cv"
}


const cms_edge = new HttpLink({
    // uri: 'http://173.212.233.220:7020/api/cms-edge/v1/graphql',
    // uri: 'https://app.orangefit.am/api/cms-edge/v1/graphql',
    uri: APP_URLS.cms_edge
})
const cms = new HttpLink({
    // uri: 'http://173.212.233.220:7010/api/cms/v1/graphql',
    // uri: 'https://app.orangefit.am/api/cms/v1/graphql',
    uri: APP_URLS.cms
})

export const apolloClient = new ApolloClient({
    link: ApolloLink.split(
        operation => operation.getContext().clientName === 'cms',
        cms,
        cms_edge, //if above
    ),
    cache: cache,
});

